import type { ApiClient } from "@pokifolio/api-client";
import type { ReactNode } from "react";

import { ApiContext } from "./api-context";

/** Makes the API client available to every screen. Tests pass a fake client here. */
export function ApiProvider({ api, children }: { api: ApiClient; children: ReactNode }) {
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}
